import { db } from '@/lib/db';
import { useAccount } from '@/hooks/useAccount';
import { SearchHistoryItem } from '@/types';
import { Box, Divider, ScrollArea, Stack, Text } from '@mantine/core';
import { useLiveQuery } from "dexie-react-hooks";

interface RecentSearchesProps {
    onSearchHistorySelected: (search: SearchHistoryItem) => void;
}

const RecentSearches:React.FC<RecentSearchesProps> = ({onSearchHistorySelected}) => {
    const { userId } = useAccount();
    const searchHistory = useLiveQuery(async () => (await db.searchHistory.where('ownerId').equals(userId).sortBy('createdAt')).reverse(), [userId]);
    const searchHistoryClickHandler = (search: SearchHistoryItem) => {
        onSearchHistorySelected(search);
    }
    return (
        <>
            <Text mx="md" mt={3} size="md">Recent Searches</Text>
            <ScrollArea h='100%' py={5}>
                <Stack gap={3} mx="md">
                    {searchHistory?.map((history:SearchHistoryItem, i: number) => (
                        <Box key={i} onClick={() => searchHistoryClickHandler(history)}>
                            <Text size="sm" fw="800">{history.search}</Text>
                            <Text size="xs">{history.county}</Text>
                            {
                                searchHistory.length - 1 !== i && <Divider m={0} />
                            }
                        </Box>           
                    ))}
                </Stack>
            </ScrollArea>
        </>
    )
}

export default RecentSearches;
